module.exports = __webpack_public_path__ + "static/img/esport.5eb35927.png";